<template>
    <div class="main">
        <h2>Local Config</h2>
        <p>Will be saved in localstorage</p>
        <div class="option">
            <div class="label">Disable Weather</div>
            <input type="checkbox" v-model="options.diableweather">
        </div>
        <div class="option">
            <div class="label">Location -> overridden with url query (?startpoint=C1)</div>
          <select v-model="options.location">
            <option v-for="loc in startpoints" :value="loc.id">{{loc.slug}} ({{ loc.id }})</option>
          </select>

        </div>
        <div class="option">
            <div class="lalbel">Scale Frontend</div>
            <input type="checkbox" v-model="options.scaleFE">
        </div>
        <div class="option">
            <div class="lalbel">Return to home</div>
            <input type="checkbox" v-model="options.returnToHome">
        </div>
        <div class="option">
            <div class="label">Enable Cache (after change refresh browser)</div>
            <input type="checkbox" v-model="options.enableCache">
            <br>
            Cache date: {{options.cacheDate}}<br>
            <button class="btn" @click="updateCache()">Update Cache</button>
        </div>
        <button @click="save()">Save</button>
    </div>

</template>
<script>
    import axios from "axios";
    import * as nodelib from '@/nodes.js'

    export default {
        name: 'LocalConfig',
        data() {
            return {
             nodes:  false
            }
        },
        created(){
          this.nodes = nodelib.nodes;
        },
        props: ['options', 'jsondata'],
        computed: {
          startpoints() {
            return this.nodes.filter(x=> x.isStartpoint == true)
          }
        },
        methods: {
            save(){
                localStorage.setItem("SCSNaviOptions", JSON.stringify(this.options));
                alert('options saved, please refresh the browser');
            },
            updateCache(){
                this.options.cacheDate = 'updating, please wait';
                axios.get('https://www.shoppingcityseiersberg.at/wp-json/rubikon/v1/shops').then(response => {
                    var now = new Date();
                    this.options.cacheDate = now.toString();
                    localStorage.setItem("SCSNaviData", JSON.stringify(response.data));
                    alert('cache updated');
                }, error => {
                    console.log('axios error' + error)
                });
            }
        }
    }
</script>

<style lang="scss">
    .option {
        margin-bottom: 20px;
        position: relative;
        padding-left: 25px;

        input[type=checkbox]{
            position: absolute;
            left: 0;
            top: 3px;
        }
    }
</style>